// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1gDJT","colMaxWidth":"Table_colMaxWidth__36E8y"};